import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig } from '../c4-input';
import { C4Form } from '../c4-form';

@Component({
  selector: 'c4-input-text',
  templateUrl: 'c4-input-text.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputText extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() prefix: string;
  @Input() suffix: string;
  @Input() readonly: boolean;

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/text/c4-input-text.ts